import {
  fetchAllDashboards,
  fetchVolunteerStats,
  fetchWorshippersStats,
  fetchHalaqatStats,
  fetchDeadcareStats,
  fetchMaqariStats,
  type DashboardFilters
} from '@/services/dashboard'
import { useQuery } from '@tanstack/vue-query'
import type { ComputedRef, Ref } from 'vue'

export const useAllDashboards = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['all-dashboards', filters],
    queryFn: () => fetchAllDashboards(filters.value)
  })

export const useVolunteerStats = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['volunteer-stats', filters],
    queryFn: () => fetchVolunteerStats(filters.value)
  })

export const useWorshippersStats = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['worshippers-stats', filters],
    queryFn: () => fetchWorshippersStats(filters.value)
  })

export const useHalaqatStats = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['halaqat-stats', filters],
    queryFn: () => fetchHalaqatStats(filters.value)
  })

export const useDeadcareStats = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['deadcare-stats', filters],
    queryFn: () => fetchDeadcareStats(filters.value)
  })

export const useMaqariStats = (
  filters: ComputedRef<DashboardFilters> | Ref<DashboardFilters>
) =>
  useQuery({
    queryKey: ['maqari-stats', filters],
    queryFn: () => fetchMaqariStats(filters.value)
  })
